import { useEffect, useState } from "react";
import PayloadModal from "../PayloadModal/PayloadModal";
import api from "../../../services/api";

const PendingRequestModal = ({ mc_id,isOpen, onClose}) => {
    const [mcAction, setMcAction] = useState('');
    const getMackerCheckerAction = async () => {
        const result = await api({
            url: `/makerchecker/getMackerCheckerAction`,
            method: "POST",
            data: { mc_id } 
        });
        if(result.status === 'SUCCESS') {
            setMcAction(result.data);
        }
    }
    useEffect(() => {
       if(!isOpen || !mc_id)  return;
       getMackerCheckerAction();
    }, [mc_id,isOpen])
    if(!isOpen) return null;
    return (
        // PayloadModal now derives the comparison from mcAction itself (it needs
        // payload_version/request_payload/payload_difference to pick the right renderer),
        // so the separate payload/updatedPayload props are gone.
        <PayloadModal mcAction={mcAction} isOpen={isOpen} onClose={onClose} />
    )
}
export default PendingRequestModal;